import React from 'react';
import {useTags} from '../../hooks/api/tags';
import {AccountFilterCondition} from '../../shared/filter/accountFilter';
import {useIsFeatureEnabled} from '../../hooks/api/metadata';

/**
 * Standalone filter options for the DynamicListEditorModal.
 * Unlike useFilterOptions (which depends on AccountGrid context),
 * this provides a simplified set of options usable from the AccountLists page.
 */
export const useDynamicListFilterOptions =
  (): AccountFilterCondition['field'][] => {
    const tags = useTags({type: 'static'});
    const isIntentEnabled = useIsFeatureEnabled('intent');

    return React.useMemo(() => {
      return [
        'tier',
        isIntentEnabled && 'intentTier',
        'similarTo',
        'signals',
        isIntentEnabled && 'matchedIntentFields',
        !!tags.data?.length && 'tags',
        'primaryCategory',
        'audience',
        'inCRM',
        'inSAM',
        'employees',
        'funding',
        'trafficRank',
        'hqCountry',
        'hqState',
      ].filter(Boolean) as AccountFilterCondition['field'][];
    }, [tags.data, isIntentEnabled]);
  };
